(ns practitest.frontend.smart-fox
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [goog.object :as gobj]
   [practitest.frontend.common.dom :as dom]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.common.utils :as utils]
   [practitest.frontend.components.icons :as icons]
   [practitest.frontend.components.navigation :as navigation]
   [practitest.frontend.components.overlay2 :as overlay2]
   [practitest.frontend.components2.spinners :as spinners]
   [practitest.frontend.components.tooltip :as tooltip]
   [practitest.frontend.init :as init]
   [practitest.frontend.subs :as subs]
   [re-frame.core :as re-frame]
   [reagent.core :as reagent]))

;; events
(re-frame/reg-event-db
 ::init-smart-fox
 (fn [db [_ data]]
   (update db :smart-fox-state merge data)))

(defn update-element [field
                      id
                      new-value
                      step-changed-hidden-elem]

  (let [container-elem (js/document.getElementById (str id field))
        textarea-elem (when container-elem (.querySelector container-elem "textarea"))

        codemirror-div (when container-elem (.querySelector container-elem ".CodeMirror"))
        codemirror-span (when codemirror-div (.querySelector codemirror-div "span"))

        view-mode-div (when container-elem (.querySelector container-elem ".step_design_view_mode_area"))
        view-mode-p (when view-mode-div (.querySelector view-mode-div "p"))]

    (when container-elem
      (when (not= new-value "")
        (when view-mode-p
          (set! (.-textContent view-mode-p) new-value))     ; for the p when view mode
        (when codemirror-span
          (set! (.-textContent codemirror-span) new-value)) ; for the span when codemirror edit mode
        (when textarea-elem
          (set! (.-value textarea-elem) new-value))         ; for the textarea when view mode and then codemirror edit mode
        (when step-changed-hidden-elem
          (set! (.-value step-changed-hidden-elem) "true")) ; for the step value to be changed when clicking save button
        ))))

(defn process-steps [steps]
  (let [steps (js/JSON.parse steps)]
    (doseq [step steps]
      (let [id (gobj/get step "id")
            new-description (gobj/get step "description")
            new-expected-results (gobj/get step "expected_results")

            step-container-elem (.querySelector js/document (str "[step_design_id=\"" id "\"]")) ; for the hidden field 'step_changed', set to true
            step-changed-hidden-elem (when step-container-elem (.querySelector step-container-elem "#step_changed"))]

        ;; Update description
        (update-element "_description"
                        id
                        new-description
                        step-changed-hidden-elem)

        ;; Update expected results
        (update-element "_expected_results"
                        id
                        new-expected-results
                        step-changed-hidden-elem)))))

(defn smart-fox-apply [{:keys [db]} [_ test-id operation]]
  {:db         (update db :progress conj ::smart-fox-apply)
   :http-xhrio {:method          :post
                ;; This is fine for now
                :uri             (get-in db [:smart-fox-state :smart-fox-apply-uri])
                :params          {:id test-id :operation operation}
                :format          (ajax/json-request-format)
                :response-format (ajax/json-response-format {:keywords? true})
                :on-success      [::smart-fox-apply-completed]
                :on-failure      [::smart-fox-apply-completed]}})

(re-frame/reg-event-fx ::smart-fox-apply smart-fox-apply)

(defn switch-to-steps-tab []
  (let [tabs-elem-ul (js/document.getElementById "common_entity_main_tab_js")
        active-tab-li (when tabs-elem-ul (.querySelector tabs-elem-ul ".active"))
        steps-tab-li (.querySelector js/document ".steps_tab_in_new_test")
        steps-link (js/document.getElementById "test_design_steps_tab")

        tabs-elem-divs (.querySelector js/document ".common_entity_all_tabs_js")
        active-tab-div (when tabs-elem-divs (.querySelector tabs-elem-divs ".active"))]

    (.click steps-link)
    (when active-tab-li
      (.setAttribute active-tab-li "class" (.replace (.getAttribute active-tab-li "class") "active" "")))
    (when active-tab-div
      (.setAttribute active-tab-div "class" (.replace (.getAttribute active-tab-div "class") "active" "")))
    (when steps-tab-li
      (.setAttribute steps-tab-li "class" (.replace (.getAttribute steps-tab-li "class") "" "active ")))))

(defn smart-fox-apply-completed [{:keys [db]} [_ {:keys [operation message code steps]}]]
  (switch-to-steps-tab)
  (if (= operation "generate-steps")
    (js/location.reload)
    (process-steps steps))
  {:db (-> db
           (update :progress disj ::smart-fox-apply))
   :dispatch [(if (= code 200) ::notifications/success2 ::notifications/error2)
              message
              {:auto-close (if (= code 200) 2000 20000)}]})

(re-frame/reg-event-fx ::smart-fox-apply-completed smart-fox-apply-completed)

;; subs
(re-frame/reg-sub
 ::state
 (fn [db _]
   (:smart-fox-state db)))

(re-frame/reg-sub
 ::generative-ai-consent?
 :<- [::state]
 (fn [{:keys [generative-ai-consent?]} _]
   generative-ai-consent?))

(re-frame/reg-sub
 ::generate-steps-enabled?
 :<- [::state]
 (fn [{:keys [generate-steps-enabled?]} _]
   generate-steps-enabled?))

(re-frame/reg-sub
 ::improve-steps-enabled?
 :<- [::state]
 (fn [{:keys [improve-steps-enabled?]} _]
   improve-steps-enabled?))

(re-frame/reg-sub
 ::labels
 :<- [::state]
 (fn [{:keys [labels]} _]
   labels))

(re-frame/reg-sub
 ::entity-id
 :<- [::state]
 (fn [{:keys [entity-id]} _]
   entity-id))

(defn smart-fox-action [enabled? confirm-txt spinner-label spinner-label-value dispatch-action]
  (let [confirmed? (reagent/atom false)]
    (fn [_]
      (when enabled?
        (reset! confirmed? (js/window.confirm confirm-txt))
        (reset! spinner-label spinner-label-value)
        (when @confirmed?
          (re-frame/dispatch dispatch-action))))))

(defn smart-fox-params [spinner-label labels]
  (let [{:keys [generate-steps shorten-steps expand-steps change-steps-tone fix-steps-grammar confirm-txt]} labels
        confirm-txt (str/replace confirm-txt #"\\n" "\n")
        {{:keys [generate-disabled-txt improve-disabled-txt]} :tooltips} labels
        generate-steps-enabled? @(re-frame/subscribe [::generate-steps-enabled?])
        improve-steps-enabled? @(re-frame/subscribe [::improve-steps-enabled?])
        test-id @(re-frame/subscribe [::entity-id])]
    [{:text                  generate-steps
      :id                    "smart-fox-menu-generate-steps"
      :disabled?             (not generate-steps-enabled?)
      :disabled-tooltip?     (not generate-steps-enabled?)
      :disabled-tooltip-text generate-disabled-txt
      :on-click              (smart-fox-action generate-steps-enabled?
                                               confirm-txt spinner-label
                                               {:value "Generating steps..."
                                                :translation "smart-fox.spinner.generate-steps"}
                                               [::smart-fox-apply test-id :generate-steps])
      :mixpanel              ["Smart fox" {"Entity" "Test" "Action" "Generate Steps"}]
      :icon                  icons/mux-generate-steps
      :offset                [-100 11]}
     {:text                  shorten-steps
      :id                    "smart-fox-menu-shorten-steps"
      :disabled?             (not improve-steps-enabled?)
      :disabled-tooltip?     (not improve-steps-enabled?)
      :disabled-tooltip-text (str "Shorten Steps " improve-disabled-txt)
      :on-click              (smart-fox-action improve-steps-enabled?
                                               confirm-txt spinner-label
                                               {:value "Shortening steps..."
                                                :translation "smart-fox.spinner.shorten-steps"}
                                               [::smart-fox-apply test-id :shorten-steps])
      :mixpanel              ["Smart fox" {"Entity" "Test" "Action" "Shorten Steps"}]
      :icon                  icons/mux-shorten-steps
      :offset                [-100 11]}
     {:text                  expand-steps
      :id                    "smart-fox-menu-expand-steps"
      :disabled?             (not improve-steps-enabled?)
      :disabled-tooltip?     (not improve-steps-enabled?)
      :disabled-tooltip-text (str "Expand Steps " improve-disabled-txt)
      :on-click              (smart-fox-action improve-steps-enabled?
                                               confirm-txt spinner-label
                                               {:value "Expanding steps..."
                                                :translation "smart-fox.spinner.expand-steps"}
                                               [::smart-fox-apply test-id :expand-steps])
      :mixpanel              ["Smart fox" {"Entity" "Test" "Action" "Expand Steps"}]
      :icon                  icons/mux-expand-steps
      :offset                [-100 11]}
     {:text                  change-steps-tone
      :id                    "smart-fox-menu-change-steps-tone"
      :disabled?             (not improve-steps-enabled?)
      :disabled-tooltip?     (not improve-steps-enabled?)
      :disabled-tooltip-text (str "Change steps tone " improve-disabled-txt)
      :on-click              (smart-fox-action improve-steps-enabled?
                                               confirm-txt spinner-label
                                               {:value "Changing steps tone..."
                                                :translation "smart-fox.spinner.changing-steps-tone"}
                                               [::smart-fox-apply test-id :change-steps-tone])
      :mixpanel              ["Smart fox" {"Entity" "Test" "Action" "Change steps tone"}]
      :icon                  icons/mux-change-steps-tone
      :offset                [-100 11]}
     {:text                  fix-steps-grammar
      :id                    "smart-fox-menu-fix-steps-grammar"
      :disabled?             (not improve-steps-enabled?)
      :disabled-tooltip?     (not improve-steps-enabled?)
      :disabled-tooltip-text (str "Fix steps grammar " improve-disabled-txt)
      :on-click              (smart-fox-action improve-steps-enabled?
                                               confirm-txt spinner-label
                                               {:value "Fixing steps grammar..."
                                                :translation "smart-fox.spinner.fix-steps-grammar"}
                                               [::smart-fox-apply test-id :fix-steps-grammar])
      :mixpanel              ["Smart fox" {"Entity" "Test" "Action" "Fix steps grammar"}]
      :icon                  icons/mux-fix-grammar-steps
      :offset                [-100 11]}]))

;; views
(defn smart-fox-ui [_]
  (let [root-ref (atom nil)
        tooltip-overlay-state (reagent/atom {})
        spinner-label (reagent/atom {:value "" :translation ""})]
    (fn [{:keys [webcomponent?] :as options}]
      (let [labels @(re-frame/subscribe [::labels])
            {:keys [smart-fox-ai-assistant consent-is-needed]} labels
            generative-ai-consent? @(re-frame/subscribe [::generative-ai-consent?])
            progress? (re-frame/subscribe [::subs/progress? ::smart-fox-apply])]
        [:span
         {:class (dom/classes-pairs :webcomponent webcomponent?)
          :ref   (dom/root-ref-handler root-ref)}
         [:<>
          [:span
           (let [hide! (fn []
                         (swap! tooltip-overlay-state assoc :show-smart-fox-menu? false))
                 toggle! (fn []
                           (swap! tooltip-overlay-state update :show-smart-fox-menu? not))
                 show? (:show-smart-fox-menu? @tooltip-overlay-state)]
             [overlay2/floating-ui-overlay
              {:placement        "bottom-end"
               :offset           20
               :container        root-ref
               :show?            show?
               :on-request-close hide!}
              ;; Target
              [tooltip/mux-tooltip
               {:position "left"
                :offset [13 11]}
               (if generative-ai-consent?
                 smart-fox-ai-assistant
                 consent-is-needed)
               (fn [props]
                 [:span
                  (assoc props
                         :id "smart-fox-menu"
                         :on-click (fn [_]
                                     (toggle!)))
                  (if generative-ai-consent?
                    [icons/mux-smart-fox]
                    [icons/mux-smart-fox-grey])])]
              ;; Body
              (when generative-ai-consent?
                [:div
                 [:div.menu-popup
                  (for [params (smart-fox-params spinner-label labels)]
                    ^{:key (:id params)}
                    [navigation/menu-item-element params])]])])]
          [spinners/modal-spinner {:show? progress?
                                   :body [:<>
                                          [:div.fullscreen-spinner
                                           [icons/mux-smart-fox]]
                                          [:div.text
                                           (get-translation (:translation @spinner-label)
                                                            (:value @spinner-label))]]}]]]))))

(defn ^:dev/after-load mount-root []
  (init/remount-roots "smart-fox-component"
                      smart-fox-ui))

(defn ^:export init [webcomponent options]
  (init/init! {:options       options
               :init-event-fn (fn [config]
                                [::init-smart-fox config])
               :webcomponent  webcomponent
               :root-view     smart-fox-ui}))

(utils/register-webcomponent! "smart-fox-component")
